export const CoachingScope = ({ light = false }) => (
  <p className={`mt-4 max-w-xl text-center text-sm leading-relaxed sm:text-left ${light ? "text-[#d9cfc2]" : "text-[#5d544c]"}`}>
    Lifestyle coaching focused on personal goals, daily habits and self-exploration.
  </p>
);
